import { privateApi, privateApiWithBlob } from "../api/axios";

export const getInvoicesTemplates = async () => {
    try {
        const response = await privateApi.get("api/invoicestemplates");
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteInvoiceTemplate = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/invoicestemplates/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const addInvoiceTemplate = async (file: File) => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await privateApiWithBlob.post("api/invoicestemplates", formData);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getInvoiceTemplate = async (id: number) => {
    try {
        const response = await privateApiWithBlob.get(`api/invoicestemplates/${id}`, {
            responseType: 'blob'
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateInvoiceTemplate = async (id: number, file: File) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await privateApiWithBlob.patch(`api/invoicestemplates/${id}`, formData);
        return response;
    } catch (error) {
        throw error;
    }
}